import { PropsWithChildren } from "react";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { getIsTopologicalEmbeddingLoading } from "#modules/similarPart/domain/isEmbeddingLoading";
import { AutoLoader } from "#modules/similarPart/view/AutoLoader";
import { Flex } from "#shared/view/components/Flex";
import { Image } from "#shared/view/components/Image";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { JobStatusSchema } from "shared";

export const EmbeddingErrorCheck = ({
  part,
  checkPart,
  children,
}: {
  part: PartDto | null;
  checkPart: (params: { id: string; force?: boolean }) => void;
} & PropsWithChildren) => {
  const isEmbeddingProcessing = getIsTopologicalEmbeddingLoading(part);

  if (!part) {
    return (
      <Text inline fz="sm" mt={"sm"}>
        Aucune pièce n'a été chargée.
      </Text>
    );
  }

  if (isEmbeddingProcessing) {
    return (
      <Stack align={"center"} justify={"center"}>
        <Image src="/images/search.png" w={150} h={150} />
        <Text inline fz="sm">
          Plus que quelques secondes d'analyse avant de pouvoir rechercher des pièces similaires...
        </Text>
        <AutoLoader />
      </Stack>
    );
  }

  if (part.embeddingStatus === JobStatusSchema.enum.ERROR) {
    return (
      <Flex>
        <Text inline fz="sm" c="error">
          {"Impossible de rechercher les pièces similaires car l'analyse de la pièce a échoué."}
          <Text
            onClick={() => checkPart({ id: part.id, force: true })}
            span
            inherit
            c="blue"
            ml="xs"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Réessayer
          </Text>
        </Text>
      </Flex>
    );
  }

  return children;
};
